module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.contrato.itensContrato.contrato_id && this.$store.state.fornecedor.dadosFornecedor !== null) ? _c('div', {
    staticClass: "container-visualizacao-sla"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('vue-position-sticky', {
    staticClass: "ajusta-cabecalho-impressao"
  }, [_c('div', {
    staticClass: "sticky"
  }, [_c('div', {
    staticClass: "box-header with-border desabilitar-impressao"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.exibeModalAdicionarEvidencia
    }
  }, [_vm._v("Adicionar evidência")]), _vm._v(" "), (this.$store.state.contrato.itensContrato.tipo_contrato_id != 3 && this.$store.state.contrato.itensContrato.tipo_contrato_id != 4) ? _c('b-button', {
    attrs: {
      "variant": "primary evidencia-retencao"
    },
    on: {
      "click": _vm.exibeModalAdicionarGlosa
    }
  }, [_vm._v("Adicionar evidência de glosa")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "text-center desabilitar-impressao"
  }, [_c('h4', [_c('strong', [_vm._v("CONTROLE E APURAÇÃO DE SLA")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-6 label-cabecalho"
  }, [_c('label', {
    staticClass: "label-cabecalho"
  }, [_vm._v("Fornecedor: ")]), _vm._v("\n              " + _vm._s(typeof _vm.cabecalho_sla.fornecedor !== "undefined" ? _vm.cabecalho_sla.fornecedor : '') + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 label-cabecalho"
  }, [_c('label', {
    staticClass: "label-cabecalho"
  }, [_vm._v("Nº Contrato: ")]), _vm._v("\n              " + _vm._s(typeof _vm.cabecalho_sla.numero_contrato_original !== "undefined" ? _vm.cabecalho_sla.numero_contrato_original : '') + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 label-cabecalho"
  }, [_c('label', {
    staticClass: "label-cabecalho"
  }, [_vm._v("Natureza: ")]), _vm._v("\n              " + _vm._s(typeof _vm.cabecalho_sla.natureza !== "undefined" ? _vm.cabecalho_sla.natureza : '') + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sticky descricao"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed table-hover",
    attrs: {
      "border": "1"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "desabilitar-impressao"
  }, [_c('th', {
    attrs: {
      "id": "item"
    }
  }, [_vm._v("ITEM")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "id": "descricao",
      "align": "center",
      "colspan": "15"
    }
  }, [_vm._v("DESCRIÇÃO")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed table-hover",
    attrs: {
      "border": "1"
    }
  }, [_vm._l((_vm.itens_sla), function(item) {
    return _c('tbody', [_c('tr', [_c('td', {
      staticClass: "numero-item bg-color-extremidades alinhar-conteudo fonte-tabela",
      attrs: {
        "rowspan": "7"
      }
    }, [_vm._v(" " + _vm._s(item.numero_item))]), _vm._v(" "), _c('td', {
      staticClass: "descricao-sla bg-color-extremidades fonte-tabela",
      attrs: {
        "colspan": "25"
      }
    }, [_vm._v(_vm._s(item.descricao))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detalhe-descricao fonte-tabela",
      attrs: {
        "colspan": "15"
      }
    }, [_vm._v(_vm._s(item.detalhamento_descricao))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "fonte-color-unidade-medicao fonte-tabela",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v(_vm._s(item.unidade_medicao_tipo))]), _vm._v(" "), _c('td', {
      staticClass: "alinhar-conteudo fonte-color-unidade-medicao fonte-tabela"
    }, [_c('strong', [_vm._v(_vm._s(item.peso_item))])]), _vm._v(" "), _c('td', {
      staticClass: "fonte-color-unidade-medicao fonte-tabela",
      attrs: {
        "colspan": "9"
      }
    }, [_vm._v("\n              Pontos - Inicia com 10 pts / perde " + _vm._s(item.peso_item) + " " + _vm._s(item.texto_taxa) + "\n            ")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "meta-pontuacao fonte-tabela"
    }, [_vm._v("Meta de pontuação")]), _vm._v(" "), _c('td', {
      staticClass: "meta-pontuacao-valor alinhar-conteudo fonte-tabela"
    }, [_vm._v(_vm._s(item.meta_pontuacao))]), _vm._v(" "), _vm._l((_vm.meses), function(mes) {
      return _c('td', {
        staticClass: "meses alinhar-conteudo fonte-tabela"
      }, [_c('strong', [_vm._v(_vm._s(mes.sigla))])])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "nao-conformidades fonte-tabela",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Qtde de não-conformidades")]), _vm._v(" "), _vm._l((item.quantidade_apurada.mes), function(mes) {
      return _c('td', {
        staticClass: "meses alinhar-conteudo fonte-tabela"
      }, [(mes.total_nao_conformidades != 0 || _vm.existeEvidenciasAnuladas(mes.evidencias)) ? _c('a', {
        attrs: {
          "href": "javascript:void(0)",
          "data-toggle": "modal",
          "data-target": "#listarEvidencias"
        },
        on: {
          "click": function($event) {
            return _vm.listarEvidenciaAtual(mes.evidencias)
          }
        }
      }, [_vm._v("\n                " + _vm._s(mes.total_nao_conformidades) + "\n              ")]) : _c('span', [_vm._v(_vm._s(mes.total_nao_conformidades))])])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "pontuacao-alcada fonte-tabela",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Pontuação alcançada")]), _vm._v(" "), _vm._l((item.quantidade_apurada.mes), function(mes) {
      return _c('td', {
        staticClass: "meses alinhar-conteudo fonte-tabela"
      }, [_vm._v("\n              " + _vm._s(mes.pontuacao_alcancada) + "\n            ")])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "multa fonte-tabela",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("% multa")]), _vm._v(" "), _vm._l((item.quantidade_apurada.mes), function(mes) {
      return _c('td', {
        staticClass: "meses alinhar-conteudo fonte-tabela"
      }, [_vm._v("\n              " + _vm._s(mes.multa) + "\n            ")])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "fonte-tabela exibicao-evidencias-por-mes",
      attrs: {
        "colspan": "15"
      }
    }, [_c('exibir-evidencia-impressao', {
      attrs: {
        "evidencia": item.quantidade_apurada.mes
      }
    })], 1)])])
  }), _vm._v(" "), _c('tbody', {
    staticClass: "ajusta-resultado-calculo-impressao"
  }, [_c('tr', [_c('td', {
    staticClass: "percentual-multa-periodo bg-color-calculo-total-sla",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Percentual de Multa no período (%)")]), _vm._v(" "), _vm._l((_vm.percentual_multa_periodo), function(percentual) {
    return _c('td', {
      staticClass: "bg-color-calculo-total-sla text-center"
    }, [_vm._v("\n              " + _vm._s(percentual) + "\n            ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "valor-mensal-contrato bg-color-calculo-total-sla",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Valor Mensal do Contrato")]), _vm._v(" "), _vm._l((_vm.valor_mensal_contrato), function(valor_mensal) {
    return _c('td', {
      staticClass: "valor-contrato bg-color-calculo-total-sla text-center"
    }, [_vm._v("\n              " + _vm._s(valor_mensal.moeda) + "\n            ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "valor-multa bg-color-calculo-total-sla",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Valor da multa (R$)")]), _vm._v(" "), _vm._l((_vm.valor_multa), function(multa) {
    return _c('td', {
      staticClass: "bg-color-calculo-total-sla text-center"
    }, [_vm._v("\n              " + _vm._s(multa.moeda) + "\n            ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "valor-multa-utilizado-extra-mensal bg-color-calculo-total-sla",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Valor multa utilizado - Extra Mensal")]), _vm._v(" "), _vm._l((_vm.multa_extra_mensal), function(multa_extra) {
    return _c('td', {
      staticClass: "bg-color-calculo-total-sla text-center"
    }, [_vm._v("\n              " + _vm._s(multa_extra.moeda) + "\n            ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "valor-multa-a-ser-aplicada bg-color-calculo-total-sla",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Valor da multa a ser aplicada (R$)")]), _vm._v(" "), _vm._l((_vm.valor_multa_aplicada), function(multa_aplicada) {
    return _c('td', {
      staticClass: "valor-contrato text-center"
    }, [_vm._v("\n              " + _vm._s(multa_aplicada.moeda) + "\n            ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "indice-performance bg-color-calculo-total-sla",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Índice de performance")]), _vm._v(" "), _vm._l((_vm.indice_performance), function(performance) {
    return _c('td', {
      staticClass: "bg-color-calculo-total-sla text-center"
    }, [_vm._v("\n              " + _vm._s(performance) + "\n            ")])
  })], 2)])], 2), _vm._v(" "), (this.$store.state.contrato.itensContrato.tipo_contrato_id != 3 && this.$store.state.contrato.itensContrato.tipo_contrato_id != 4) ? _c('table-glosa-evidencia', {
    attrs: {
      "contrato": _vm.contrato,
      "fornecedor": (this.$store.state.fornecedor.dadosFornecedor.fornecedor_id !== '-- Selecionar Fornecedor --') ? this.$store.state.fornecedor.dadosFornecedor.fornecedor_id : null,
      "ano": _vm.anoSelecionado
    }
  }) : _vm._e(), _vm._v(" "), _c('table-fechamento-multa-glosa', {
    attrs: {
      "contrato": _vm.contrato,
      "ano": _vm.anoSelecionado,
      "uf": _vm.ufIdSelecionada,
      "fornecedor": (this.$store.state.fornecedor.dadosFornecedor.fornecedor_id !== '-- Selecionar Fornecedor --') ? this.$store.state.fornecedor.dadosFornecedor.fornecedor_id : null,
      "multas": _vm.valor_multa
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "grupo-botoes-rodape desabilitar-impressao"
  }, [_c('button', {
    staticClass: "btn btn-historico btn-default desabilitar-impressao",
    attrs: {
      "variant": "primary",
      "data-toggle": "modal",
      "data-target": "#modalHistoricoSla"
    },
    on: {
      "click": function($event) {
        return _vm.listarHistoricoSla()
      }
    }
  }, [_vm._v("Histórico")]), _vm._v(" "), _c('exportar-sla')], 1)]) : (_vm.semresultado !== null) ? _c('div', {
    staticClass: "sem-contrato"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Selecione estado e contrato")])]) : _c('div', {
    staticClass: "sem-contrato"
  }, [_c('p', [_vm._v("Selecione estado e contrato")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Não foi encontrado contrato com os filtros selecionados")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-403038ab!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sla/ControleApuracaoSla.vue
// module id = 980
// module chunks = 1